<template>
  <div id="general">
    <!-- 工作任务分解 -->
    <van-divider v-if="getWork().IsSplit==1">
      工作任务分解
      <div
        class="ml-2"
        :class="ProcessData.IsFinally ? 'color-gray' : 'color-blue'"
      >
        <i class="fa fa-fw fa-plus"></i>
        <small @click="showSubProcess">创建</small>
      </div>
    </van-divider>
    <div class="m-2 text-left">
      <van-cell
        :label="item.Memo"
        v-for="(item, index) in ProcessData.SplitProcessList"
        :key="index"
      >
        <template slot="icon">
          <i
            class="p-1 mr-1 fa"
            :class="
              item.ProcessStatus != 1
                ? 'fa-circle-thin'
                : 'color-green fa-check-square-o'
            "
          ></i>
        </template>
        <template slot="title">{{ item.ProcessName }}</template>
        <template slot="label">
          {{ item.OrganName }}
          <i
            v-if="item.ProcessStatus != 1"
            class="fa fa-fw fa-volume-up color-red ml-1"
            @click="pushBtn(item.SplitProcessID)"
          ></i>
          <!-- 工作任务分解对象列表 -->
          <div>
            <div
              class="mt-1 ml-4 w-100"
              v-for="(sub_e, sub_i) in item.UserList"
              :key="sub_i"
            >
              <i
                class="fa fa-fw"
                :class="sub_e.Status == 1 ? 'fa-check-square-o' : 'fa-minus'"
              ></i>
              <template v-if="sub_e.UserID">
                {{ sub_e.RoleName + "-" + sub_e.RealName }}
                <i class="fa fa-fw fa-phone color-blue"></i>
                <a class="color-blue" :href="'tel:' + sub_e.Phone">{{
                  sub_e.Phone
                }}</a>
              </template>
              <template v-else>{{ sub_e.RoleName }}</template>
            </div>
          </div>
        </template>
        <template slot="right-icon">
          <i
            class="p-1 mr-1 fa fa-trash-o"
            @click="deleteSubProcessBtn(item.SplitProcessID)"
          ></i>
        </template>
      </van-cell>
    </div>
    <!--工作任务分解窗口-->
    <van-popup
      position="bottom"
      class="popup-l1"
      v-model="subProcessAttribute.sheet1"
      round
      closeable
    >
      <van-nav-bar :title="ProcessData.ProcessName" left-text="任务分解" />
      <div class="mt-4 p-4">
        <el-form label-position="left" class="m-1 text-left">
          <el-form-item label="任务名称" label-width="30%" size="mini">
            <el-input
              v-model="subProcessAttribute.ProcessName"
              style="width:100%"
              maxlength="25"
            ></el-input>
          </el-form-item>
          <el-form-item label="任务说明" label-width="30%" size="mini">
            <el-input
              v-model="subProcessAttribute.Memo"
              style="width:100%"
            ></el-input>
            <ul>
              <li
                v-for="(item, index) in subProcessAttribute.SplitStatusList"
                :key="index"
              >
                {{ item.ReportOrganName }}{{ item.ReportPostName
                }}{{ item.Status }}
              </li>
            </ul>
          </el-form-item>
          <el-form-item
            label="完成方式"
            label-width="30%"
            size="mini"
            v-show="false"
          >
            <van-radio-group
              v-model="subProcessAttribute.AutoCompletionMode"
              class="m-1"
              style="font-size:14px;"
            >
              <van-radio :name="1" class="p-1">
                并联上报
                <small>(一人上报完成状态即可)</small>
              </van-radio>
              <van-radio :name="2" class="p-1">
                串联上报
                <small>(需要所有人上报完成)</small>
              </van-radio>
            </van-radio-group>
          </el-form-item>
          <el-form-item label="最终任务" label-width="30%" size="mini">
            <van-checkbox
              v-model="subProcessAttribute.IsFinally"
              class="m-2"
              style="font-size:14px;"
              >不可分解</van-checkbox
            >
          </el-form-item>
        </el-form>
        <div>
          <van-tabs v-model="subProcessAttribute.subActive" class="mt-2">
            <van-tab
              v-if="OrganRoleUser.SelfLevel"
              title="本机构工作人员"
              class="mt-2"
            >
              <div>
                <el-form>
                  <el-form-item>
                    <el-select
                      v-if="OrganRoleUser.SelfLevel.length > 0"
                      v-model="subProcessAttribute.SelfLevel"
                      multiple
                      placeholder="请选择工作人员"
                      class="m-1"
                      style="width:90%;"
                    >
                      <el-option
                        v-for="(item, index) in OrganRoleUser.SelfLevel"
                        :key="index"
                        :label="item.RealName"
                        :value="item.UserID"
                      ></el-option>
                    </el-select>
                    <div class="m-2 color-gray" v-else>没有可选工作人员</div>
                  </el-form-item>
                </el-form>
              </div>
            </van-tab>
            <van-tab
              v-if="
                this.getWork().User.RoleTypeID != 3 && OrganRoleUser.SubLevel
              "
              title="下级机构上报"
              class="mt-2"
            >
              <el-select
                v-if="OrganRoleUser.SubLevel"
                v-model="subProcessAttribute.RangeList"
                multiple
                placeholder="请选择范围"
                class="m-1"
                style="width:90%;"
              >
                <el-option
                  v-for="(item, index) in OrganRoleUser.SubLevel.RangeList"
                  :key="index"
                  :label="item.RangeName"
                  :value="item.RangeID"
                ></el-option>
              </el-select>
              <el-select
                v-if="OrganRoleUser.SubLevel"
                v-model="subProcessAttribute.RoleList"
                multiple
                placeholder="请选择岗位"
                class="m-1"
                style="width:90%;"
              >
                <el-option
                  v-for="(item, index) in OrganRoleUser.SubLevel.RoleList"
                  :key="index"
                  :label="item.RoleName"
                  :value="item.RoleID"
                ></el-option>
              </el-select>
            </van-tab>
          </van-tabs>
        </div>
        <div class="m-4">
          <van-button
            @click="addSubProcessBtn"
            round
            type="info"
            hairline
            class="w-100"
            >提交</van-button
          >
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "general",
  data () {
    return {
      OrganRoleUser: {},
      subProcessAttribute: {
        enable: true,
        sheet1: false,
        subActive: 0,
        ProcessName: "",
        Memo: "",
        AutoCompletionMode: 2,
        IsFinally: true,
        SelfLevel: [],
        RangeList: [],
        RoleList: []
      }
    };
  },
  props: {
    SplitProcessID: String, //分解环节ID
    ProcessData: Object, //工作环节数据
    ProcessRefresh: Function, //工作环节刷新事件
    completeBtnAttribute: Object //工作环节上报完成按钮
  },
  components: {},
  methods: {
    showSubProcessOption () {
      //获取工作任务分解可选机构联系人信息
      this.apiOrganRoleUserGet(
        {
          WorkID: this.getWork().WorkID,
          OrganID: this.getAddr().OrganID
        },
        this,
        res => {
          this.OrganRoleUser = res.data; //获取同一机构联系人
        }
      );
    },
    showSubProcess () {
      if (this.ProcessData.IsFinally) {
        this.$toast("这个任务不可以执行分解操作");
      } else if (this.ProcessData.ProcessStatus == 1) {
        this.$toast("任务已完成,不可以执行分解操作");
      } else {
        this.subProcessAttribute.sheet1 = true;
      }
    },
    addSubProcessBtn () {
      this.apiWorkProcessPost(
        {
          Type: 1,
          WorkID: this.getWork().WorkID,
          OrganID: this.getAddr().OrganID,
          RoleID: this.getAddr().RoleID,
          ProcessName: this.subProcessAttribute.ProcessName,
          SplitProcessID: this.SplitProcessID,
          AutoCompletionMode: this.subProcessAttribute.AutoCompletionMode,
          IsFinally: this.subProcessAttribute.IsFinally,
          Memo: this.subProcessAttribute.Memo,
          UserList:
            this.subProcessAttribute.subActive == 0
              ? this.subProcessAttribute.SelfLevel
              : [],
          RangeList:
            this.subProcessAttribute.subActive == 0
              ? []
              : this.subProcessAttribute.RangeList,
          RoleList:
            this.subProcessAttribute.subActive == 0
              ? []
              : this.subProcessAttribute.RoleList
        },
        this,
        e => {
          this.$toast(e.message);
          if (e.code == 20000) {
            this.subProcessAttribute.sheet1 = false;
            this.subProcessAttribute = {
              sheet1: false,
              subActive: 0,
              ProcessName: "",
              Memo: "",
              AutoCompletionMode: 2,
              IsFinally: true,
              SelfLevel: [],
              RangeList: [],
              RoleList: []
            };
            this.ProcessRefresh();
          }
        }
      );
    },
    deleteSubProcessBtn (SplitProcessID) {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确定删除分解任务?"
        })
        .then(() => {
          // on confirm
          this.apiWorkProcessDelete(
            {
              WorkID: this.getWork().WorkID,
              SplitProcessID: SplitProcessID
            },
            this,
            e => {
              this.$toast(e.message);
              if (e.code == 20000) {
                this.ProcessRefresh();
              }
            }
          );
        })
        .catch(() => {
          // on cancel
        });
    },
    pushBtn (SplitProcessID) {
      //消息推送-提醒上报工作任务
      this.$dialog
        .confirm({
          title: "提示",
          message: "发送工作任务上报提醒通知给工作人员 ?"
        })
        .then(() => {
          // on confirm
          //eslint-disable-next-line
          console.log("消息提醒", this.sheet1Content);
          this.apiPushPost(
            {
              WorkID: this.getWork().WorkID,
              PushType: "splitreport",
              SplitProcessID: SplitProcessID
            },
            this,
            res => {
              //eslint-disable-next-line
              if (res.code == 20000) {
                this.$toast(res.message);
              } else {
                this.$dialog.alert({ message: res.message });
              }
            }
          );
        })
        .catch(() => {
          // on cancel
        });
    }
  },
  created () {
    this.showSubProcessOption();
  },
  mounted () { }
};
</script>

<style scoped>
</style>